import { render, staticRenderFns } from "./LabourForm.vue?vue&type=template&id=5d3acb0c&scoped=true"
import script from "./LabourForm.vue?vue&type=script&lang=js"
export * from "./LabourForm.vue?vue&type=script&lang=js"
import style0 from "./LabourForm.vue?vue&type=style&index=0&id=5d3acb0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3acb0c",
  null
  
)

export default component.exports